<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">搜索</template>
      <el-form
        ref="searchForm"
        :model="search"
        label-width="108px"
        label-position="right"
        size="medium"
        @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="题目内容"
                        prop="title">
            <el-input v-model="search.title"
                      clearable
                      placeholder="请输入题目关键词"/>
          </el-form-item>
          <el-form-item label="题目类型"
                        prop="question_type">
            <el-select v-model="search.question_type"
                       class="width-max"
                       clearable
                       multiple
                       placeholder="请选择题型">
              <el-option v-for="item in opts.questionTypeMaps"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型"
                        prop="target_usertype">
            <el-select v-model="search.target_usertype"
                       class="width-max"
                       clearable
                       placeholder="请选择用户类型">
              <el-option v-for="item in opts.targetUserMaps"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否通用"
                        prop="is_common">
            <el-select v-model="search.is_common"
                       class="width-max"
                       clearable
                       placeholder="请选择是否通用">
              <el-option v-for="item in opts.isCommonMaps"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="所属知识库"
                        prop="training_knowledge_id">
            <remote-select
              v-model="search.training_knowledge_id"
              class="width-max"
              clearable
              multiple
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入知识库名称搜索"
              :query-request="queryTrainingKnowledge"
              :find-request="getTrainingKnowledge"/>
          </el-form-item>
          <el-form-item label="所属客户"
                        prop="customerid">
            <remote-select
              v-model="search.customerid"
              class="width-max"
              clearable
              multiple
              placeholder="请输入客户关键字"
              :query-request="getCustomerTable"
              :find-request="getCustomerDetail"/>
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="search.status"
                       class="width-max"
                       clearable
                       multiple
                       placeholder="请选择状态">
              <el-option v-for="item in opts.statusMaps"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人"
                        prop="creator_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              multiple
              placeholder="请输入创建人"
              v-model="search.creator_id"
              :query-request="(params)=>getPlatformUsersIndex(Object.assign(params, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>


        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <router-link to="/training/question/create">
        <el-button type="primary"
                   size="small">创建题目
        </el-button>
      </router-link>
      <el-table :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column type="selection"
                         width="44"/>
        <el-table-column prop="id"
                         label="题目ID"
                         width="88"/>
        <el-table-column prop="status"
                         label="状态"
                         width="100">
          <template slot-scope="scope">
            <span class="question-tag"
                  :class="getStatusTagClass(scope.row.status)">
              {{ getQuestionStatusLabel(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="question_type"
                         label="题型"
                         width="105">
          <template slot-scope="scope">
            <span class="question-tag"
                  :class="getQuestionTypeTagClass(scope.row)">
              {{ getQuestionTypeLabel(getRowQuestionType(scope.row)) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="问题"
                         min-width="360">
          <template slot-scope="scope">
            <div class="question-content">
              <div class="question-content__title">{{ getQuestionTitle(scope.row) }}</div>
              <div
                v-for="(option, index) in getQuestionOptions(scope.row)"
                :key="option.uuid || index"
                class="question-content__option">
                {{ getOptionLetter(index) }}. {{ option.title }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="正确答案"
                         width="120">
          <template slot-scope="scope">
            <span class="answer-text">{{ formatStandardAnswer(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="target_usertype"
                         label="用户类型"
                         width="120">
          <template slot-scope="scope">
            <span class="question-tag"
                  :class="getTagClass('user', scope.row.target_usertype)">
              {{ getTargetUserLabel(scope.row.target_usertype) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="is_common"
                         label="是否通用"
                         width="100">
          <template slot-scope="scope">
            <span class="question-tag"
                  :class="getTagClass('common', scope.row.is_common)">
              {{ getIsCommonLabel(scope.row.is_common) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="knowledge_name"
                         label="所属知识库"
                         min-width="150">
          <template slot-scope="scope">
            <span class="knowledge-name">
              <i class="el-icon-folder knowledge-name__icon"></i>
              <span>{{ scope.row.knowledge_name || '-' }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="customer_name"
                         label="所属客户"
                         min-width="140">
          <template slot-scope="scope">{{ scope.row.customer_name || '-' }}</template>
        </el-table-column>
        <el-table-column label="答题次数"
                         prop="total_answer_times"
                         width="92"></el-table-column>
        <el-table-column label="答题人数"
                         prop="total_user_count"
                         width="92"></el-table-column>
        <el-table-column label="正确率"
                         width="92">
          <template slot-scope="scope">
            <span :class="getAccuracyClass(scope.row)">{{ formatAccuracy(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         width="170"/>
        <el-table-column prop="user_name"
                         label="创建人"
                         min-width="110">
        </el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <router-link :to="{ path: `/training/question/update/${scope.row.id}`, query: { mode: 'view' } }">
              <el-button type="primary"
                         size="mini"
                         plain>查看
              </el-button>
            </router-link>
            <router-link
              v-if="Number(scope.row.status) !== consts.QUESTION_STATUS_USING && Number(scope.row.status) !== consts.QUESTION_STATUS_BANNED"
              :to="`/training/question/update/${scope.row.id}`">
              <el-button type="success"
                         size="mini"
                         plain>修改
              </el-button>
            </router-link>
            <el-button
              v-if="(Number(scope.row.status) === consts.QUESTION_STATUS_UNUSED || Number(scope.row.status) === consts.QUESTION_STATUS_NEW) && isSuperAdmin"
              type="danger"
              size="mini"
              plain
              @click="handleQuestionAction(scope.row, 'ban')">作废
            </el-button>
            <el-button
              v-if="isSuperAdmin && Number(scope.row.status) === consts.QUESTION_STATUS_BANNED"
              type="primary"
              size="mini"
              plain
              @click="handleQuestionAction(scope.row, 'active')">激活
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          :current-page="pagination.current_page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizePageChange"
          @current-change="handleCurrentPageChange"/>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import trainingMixins from '@views/training/training.mixins'
import { getOptionLabel } from '@views/training/training-course.constants'
import { isSuperAdminUser } from '@views/training/training-user'
import {
  consts,
  getQuestionStatusActions,
  getQuestionStatusLabel,
  getQuestionStatusType,
  getQuestionTypeLabel,
  isChoiceQuestion,
  opts,
} from '@views/training/training-question.constants'
import { NumberArray } from '@utils/common'

export default {
  mixins: [table, trainingMixins],
  data () {
    return {
      consts,
      opts,
      search: {
        title: null,
        question_type: [],
        status: [],
        target_usertype: null,
        is_common: null,
        training_knowledge_id: [],
        customerid: [],
        creator_id: [],
        created_at: [],
      },
      searchFieldType: {
        open_book_exam: Number,
        target_usertype: Number,
        question_type: NumberArray,
        status: NumberArray,
        is_common: Number,
        training_knowledge_id: NumberArray,
        customerid: Array,
        creator_id: NumberArray,
        created_at: Array,
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user || {},
    }),
    isSuperAdmin () {
      return isSuperAdminUser(this.loginUser)
    },
  },
  methods: {
    ...request.map([
      'queryTrainingKnowledge',
      'getTrainingKnowledge',
      'getCustomerTable',
      'getCustomerDetail',
      'getPlatformUsersDetail',
      'getPlatformUsersIndex',
    ]),
    getTableData (params) {
      return request.page('queryTrainingQuestion', params)
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      this.onSearch()
    },
    getQuestionTypeLabel,
    getQuestionStatusLabel,
    getTargetUserLabel (value) {
      return getOptionLabel(this.opts.targetUserMaps, value) || '-'
    },
    getIsCommonLabel (value) {
      return getOptionLabel(this.opts.isCommonMaps, value) || '-'
    },
    getQuestionJson (row) {
      return row.question_json || {}
    },
    getRowQuestionType (row) {
      return row.question_type || row.type || this.getQuestionJson(row).question_type
    },
    getQuestionTitle (row) {
      return row.title || this.getQuestionJson(row).title || '-'
    },
    getQuestionOptions (row) {
      const json = this.getQuestionJson(row)
      if (Array.isArray(json.options)) {
        return json.options
      }
      return Array.isArray(row.options) ? row.options : []
    },
    getStandardAnswer (row) {
      const json = this.getQuestionJson(row)
      if (json.standard_answer !== undefined && json.standard_answer !== null) {
        return json.standard_answer
      }
      return row.standard_answer
    },
    formatStandardAnswer (row) {
      const answer = this.getStandardAnswer(row)
      if (answer === undefined || answer === null || answer === '') {
        return '-'
      }
      if (!isChoiceQuestion(this.getRowQuestionType(row))) {
        return String(answer)
      }
      const answers = Array.isArray(answer) ? answer : [answer]
      const options = this.getQuestionOptions(row)
      return answers.map(item => {
        const index = options.findIndex(option => option.uuid === item)
        return index >= 0 ? this.getOptionLetter(index) : item
      }).join(',')
    },
    getOptionLetter (index) {
      return String.fromCharCode(65 + index)
    },
    getTagClass (type, value) {
      if (type === 'question') {
        if (Number(value) === this.consts.QUESTION_TYPE_MULTI) {
          return 'question-tag--purple'
        }
        if (Number(value) === this.consts.QUESTION_TYPE_FILL_BLANK) {
          return 'question-tag--warning'
        }
        return 'question-tag--primary'
      }
      if (type === 'user') {
        return Number(value) === this.consts.TARGETUSER_TYPE_USER
          ? 'question-tag--primary'
          : 'question-tag--warning'
      }
      if (type === 'common') {
        return Number(value) === this.consts.IS_COMMON_SHARED
          ? 'question-tag--success'
          : 'question-tag--default'
      }
      return 'question-tag--default'
    },
    getQuestionTypeTagClass (row) {
      return this.getTagClass('question', this.getRowQuestionType(row))
    },
    getStatusTagClass (status) {
      return `question-tag--${getQuestionStatusType(status)}`
    },

    getAccuracyValue (row) {
      const total = Number(row['correct_count'] + row['wrong_count'])
      const correct = Number(row['correct_count'])
      if (!total || Number.isNaN(correct)) {
        return null
      }
      return (correct / total) * 100
    },
    formatAccuracy (row) {
      const value = this.getAccuracyValue(row)
      return value === null ? '-' : `${value.toFixed(1).replace(/\.0$/, '')}%`
    },
    getAccuracyClass (row) {
      const value = this.getAccuracyValue(row)
      if (value === null) {
        return 'accuracy-text'
      }
      if (value >= 80) {
        return 'accuracy-text accuracy-text--success'
      }
      if (value >= 60) {
        return 'accuracy-text accuracy-text--warning'
      }
      return 'accuracy-text accuracy-text--danger'
    },

    getActionConfig (status, name) {
      return getQuestionStatusActions(status, this.isSuperAdmin).find(action => action.name === name)
    },
    handleQuestionAction (row, name) {
      const action = this.getActionConfig(row.status, name)
      if (!action) {
        return
      }
      this.$confirm(`确定要${action.label}题目【${this.getQuestionTitle(row)}】吗？`, '提示', {type: 'warning'}).then(() => {
        request.common(action.apiName, row.id).then(() => {
          this.$message.success(action.successText)
          this.onRefresh()
        })
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.question-content {
  line-height: 20px;
  color: #1f2d3d;
}

.question-content__title {
  margin-bottom: 4px;
  font-weight: 600;
}

.question-content__option {
  color: #303133;
  font-size: 12px;
}

.answer-text {
  color: #f56c6c;
  font-weight: 600;
}

.knowledge-name {
  display: inline-flex;
  align-items: center;
  line-height: 20px;
  color: #1f2d3d;
}

.knowledge-name__icon {
  margin-right: 8px;
  color: #f5a623;
  font-size: 14px;
}

.question-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 22px;
  padding: 0 12px;
  border-radius: 11px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
}

.question-tag--primary {
  color: #409EFF;
  background-color: #ecf5ff;
}

.question-tag--success {
  color: #00a854;
  background-color: #d9f7e7;
}

.question-tag--warning {
  color: #e6a23c;
  background-color: #fdf6ec;
}

.question-tag--danger {
  color: #f56c6c;
  background-color: #fef0f0;
}

.question-tag--purple {
  color: #722ed1;
  background-color: #f4e8ff;
}

.question-tag--default {
  color: #1f2d3d;
  background-color: #f4f5f7;
}

.accuracy-text {
  color: #909399;
}

.accuracy-text--success {
  color: #00a854;
}

.accuracy-text--warning {
  color: #e6a23c;
}

.accuracy-text--danger {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/question/TrainingQuestionTable.vue